// ════════════════════════════════════════════════════════════════════════════
// M2.7 Madurez de Procesos — panel de discrepancias multi-respondedor (0735)
// Lista las preguntas BPMM con varianza entre respondentes; marca las discrepantes
// (varianza ≥ umbral del cuestionario). Solo lectura. Espejo de MadurezDiscrepancias.
// ════════════════════════════════════════════════════════════════════════════
import { useState, useEffect } from 'react';
import { fetchDiscrepanciasBpmm, type DiscrepanciaBpmm } from '../api-madurez-proceso';

const A1 = '#1F3864';
const GO = '#595959';
const GC = '#F2F2F2';
const ROJO = '#DC2626';

interface Props {
  evaluacionId: string;
  labels: {
    empty: string;
    pregunta: string;
    respondentes: string;
    varianza: string;
    discrepante: string;
  };
}

export function MadurezProcesoDiscrepancias({ evaluacionId, labels }: Props) {
  const [items, setItems] = useState<DiscrepanciaBpmm[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let activo = true;
    setLoaded(false);
    fetchDiscrepanciasBpmm(evaluacionId)
      .then((res) => {
        if (activo) {
          setItems(res.data);
          setLoaded(true);
        }
      })
      .catch(() => {
        if (activo) setLoaded(true);
      });
    return () => {
      activo = false;
    };
  }, [evaluacionId]);

  if (loaded && items.length === 0) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: GO,
          fontStyle: 'italic',
          fontSize: 11,
          minHeight: 100,
        }}
      >
        {labels.empty}
      </div>
    );
  }

  const th: React.CSSProperties = {
    padding: '4px 6px',
    color: A1,
    fontSize: 9,
    textTransform: 'uppercase',
  };

  return (
    <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
        <thead>
          <tr style={{ position: 'sticky', top: 0, background: '#fff' }}>
            <th style={{ ...th, textAlign: 'left' }}>{labels.pregunta}</th>
            <th style={{ ...th, textAlign: 'center' }}>{labels.respondentes}</th>
            <th style={{ ...th, textAlign: 'center' }}>{labels.varianza}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((d) => (
            <tr key={d.preguntaId} style={{ borderBottom: `1px solid ${GC}` }}>
              <td style={{ padding: '4px 6px', color: '#000' }}>
                {d.discrepancia && (
                  <span
                    style={{ color: ROJO, fontWeight: 800, marginRight: 4 }}
                    title={labels.discrepante}
                  >
                    ●
                  </span>
                )}
                {d.enunciado.length > 70 ? d.enunciado.slice(0, 69) + '…' : d.enunciado}
              </td>
              <td style={{ padding: '4px 6px', textAlign: 'center', color: GO }}>
                {d.nRespondentes}
              </td>
              <td
                style={{
                  padding: '4px 6px',
                  textAlign: 'center',
                  fontWeight: 700,
                  color: d.discrepancia ? ROJO : GO,
                }}
              >
                {d.varianza.toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
